import { render, staticRenderFns } from "./IntegerEditor.vue?vue&type=template&id=3f2829ab&scoped=true&"
import script from "./IntegerEditor.vue?vue&type=script&lang=js&"
export * from "./IntegerEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2829ab",
  null
  
)

export default component.exports